import styles from "./ChooseDirection.module.css";
import updateIcon from "../../../assets/icons/update.svg";
import { useContext, useState } from "react";
import { TicketContext } from "../../../helpers/context";
import { formatCity } from "../../../helpers/functions";
const InputsDirection = ({ listCitiesFrom, listCitiesTo }) => {
  const [showFrom, setShowFrom] = useState(false);
  const [showTo, setShowTo] = useState(false);
  const [newTicket, setNewTicket] = useContext(TicketContext);
  

  const reverse = () => {
       setNewTicket({...newTicket, to: newTicket.from, from: newTicket.to})
  }
  return (
    <div className={styles.direction}>
      <div className={styles.form_title}>Направление</div>

      <div className={styles.choose_direction}>
        <div className={styles.input_container}>
          <input
            value={formatCity(newTicket.from)}
            className={styles.input}
            type="text"
            placeholder="Откуда"
            onChange={(event) => {
              setNewTicket({ ...newTicket, from: event.target.value });
              setShowFrom(true);
            }}
          />
          {newTicket.from !== "" && showFrom ? (
            <div className={styles.cities_box}>
              {newTicket.from !== ""
                ? listCitiesFrom.map((el, index) => {
                    return (
                      <p
                        className={styles.city}
                        key={index}
                        onClick={() => {
                          setNewTicket({ ...newTicket, from: el.name });
                          setShowFrom(false);
                        }}
                      >
                        {el.name}
                      </p>
                    );
                  })
                : ""}
            </div>
          ) : (
            ""
          )}
        </div>
        <img className={styles.update_icon} src={updateIcon} alt="swap" onClick={()=> {
          reverse()
        }}/>
        <div className={styles.input_container}>
          <input
            value={formatCity(newTicket.to)}
            className={styles.input}
            type="text"
            placeholder="Куда"
            onChange={(event) => {
              setNewTicket({ ...newTicket, to: event.target.value });
              setShowTo(true);
            }}
          />
          {newTicket.to !== "" && showTo ? (
            <div className={styles.cities_box}>
              {newTicket.to !== ""
                ? listCitiesTo.map((el, index) => {
                    return (
                      <p
                        className={styles.city}
                        key={index}
                        onClick={() => {
                          setNewTicket({ ...newTicket, to: el.name });
                          setShowTo(false);
                        }}
                      >
                        {el.name}
                      </p>
                    );
                  })
                : ""}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default InputsDirection;
